import axios from 'axios';
import { API_BASE_URL, API_URLS } from '../config/constants';

const subCategoryService = {
  // Get all sub-categories
  getAllSubCategories: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.SUBCATEGORIES}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get sub-category by ID
  getSubCategoryById: async (subCategoryId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.SUBCATEGORY_BY_ID(subCategoryId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new sub-category
  createSubCategory: async (subCategoryData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${API_URLS.SUBCATEGORIES}`, subCategoryData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update sub-category
  updateSubCategory: async (subCategoryId, subCategoryData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.SUBCATEGORY_BY_ID(subCategoryId)}`, subCategoryData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete sub-category
  deleteSubCategory: async (subCategoryId) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}${API_URLS.SUBCATEGORY_BY_ID(subCategoryId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update sub-category status
  updateSubCategoryStatus: async (subCategoryId, isActive) => {
    try {
      const response = await axios.patch(`${API_BASE_URL}${API_URLS.SUBCATEGORY_STATUS(subCategoryId)}`, {
        is_active: isActive
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default subCategoryService;